import SelectColTable from '@/components/SelectColTable.vue';
import { pageSizes, drugTypes } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import setUrl from '@/mixins/setUrl';
import config from '@/config/index';
import Cookie from '@/utils/cookie/index'; // 必须写上传组件需要用到COOKIE

export default {
  name: 'drugInfo',
  components: { SelectColTable, HisAutocompleteSuggestions },
  mixins: [pageSize, setUrl],
  data() {
    return {
      drugTypes,
      pageSizes,
      total: 0, // 总数据条数
      query: {
        drugName: this.$route.query.drugName || '', // 药品名
        drugType: this.$route.query.drugType ? Number(this.$route.query.drugType) : -1, // 药品类型
        customType: this.$route.query.customType || '', // 自定义类型
        status: this.$route.query.status ? Number(this.$route.query.status) : 1, // 启用状态
        currentPage: 1,
        pageSize: 20,
      },
      drugNameList: [],
      multipleSelection: [],
      checkNum: 0,
      statuss: [{
        value: -1,
        label: '全部',
      }, {
        value: 1,
        label: '启用',
      }, {
        value: 2,
        label: '禁用',
      }],
      rowList: [
        {
          name: '药品名称',
          value: 'drugName',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '药品分类',
          value: 'drugTypeName',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '规格',
          value: 'specification',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '厂家',
          value: 'manufacturer',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '最近进货价',
          value: 'latesdPurchasePrice',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '零售价',
          value: 'salePrice',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '货架码',
          value: 'goodsShelfCode',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '总库存',
          value: 'inventoryStr',
          isSortable: false,
          disabled: false,
          checked: true,
        },
        {
          name: '库存阈值',
          value: 'inventoryThresholdUnit',
          isSortable: false,
          disabled: false,
          checked: false,
        },
        {
          name: '自定义分类',
          value: 'customType',
          isSortable: false,
          disabled: false,
          checked: true,
        },
      ],
      tableData: [],
      importUrl: `${config.host}/drugsManage/drugs/uploadDrugTemplate`, // 导入药品信息URL
      fileList: [], // 上传文件的数组
      uploadCookie: {
        Cookie: Cookie.get('doctorInfo'),
      },
      isShopDrugs: 0,
    };
  },
  methods: {
    // 获取药品列表信息
    getTableData(type) {
      if (type === 1) {
        this.query.currentPage = 1;
      }
      this.queryChangeHandle();
      this.$api.drugControl.drugs(this.query).then((res) => {
        console.log(res);
        this.tableData = res.drugList || [];
        this.total = res.totalSize;
      });
    },
    // 删除药品
    drugsDel(drugId, drugName) {
      this.$confirm(`确定删除${drugName}`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.$api.drugControl.drugsDel({
          id: drugId,
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getTableData(1);
        });
      }).catch(() => {
      });
    },
    // 批量删除药品
    drugsDelMore() {
      this.$api.drugControl.drugsDelMore({
        drugIds: this.multipleSelection,
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
        this.getTableData(1);
      });
    },
    // 批量编辑自定义分类
    batchModifyDrugCustomType(val) {
      this.$api.drugControl.batchModifyDrugCustomType({
        drugIds: this.multipleSelection,
        customType: val,
      }).then(() => {
        this.$message({
          type: 'success',
          message: '成功!',
        });
        this.getTableData(1);
      });
    },
    // 药品名称检索
    querySearch(str, cb) {
      this.isShopDrugs = 0;
      this.$api.drugControl.drugsNameList({
        drugName: str,
        status: this.query.status, // 药品状态
      }).then((res) => {
        if (Array.isArray(res.drugList) && res.drugList.length > 0) {
          cb(res.drugList);
        } else {
          cb([]);
        }
      });
    },
    // 选择药品名称
    selectHandle(e) {
      this.query.drugName = e.drugName;
      this.isShopDrugs = e.isShopDrugs;
      this.getTableData(1);
    },
    searchHandle(e) {
      this.query.drugName = e;
      this.getTableData(1);
    },
    // 自定义分类检索
    querySearchCustomType(queryString, cb) {
      this.$api.drugControl.customType({
        customType: this.query.customType,
      }).then((res) => {
        res.typeList = res.typeList.map(item => ({ value: item }));
        cb(res.typeList);
      });
    },
    // 选择下拉框自定义分类
    handleSelectCustomType(item) {
      this.query.customType = item.value;
      this.getTableData(1);
    },
    // 每页展示数据条数变更
    handleSizeChange(e) {
      this.query.pageSize = e;
      this.getTableData(1);
    },
    // 翻页
    handleCurrentChange(e) {
      this.query.currentPage = e;
      this.getTableData();
    },
    // 导出
    fileExport() {
      if (this.tableData.length < 1) {
        this.$alert('没有药品信息，请更换查询条件试试', '提示', {
          confirmButtonText: '确定',
        }).catch(() => {
        });
      } else {
        this.$api.drugControl.drugExport(this.query);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map(value => value.id);
      this.checkNum = this.multipleSelection.length;
    },
    getTableCol(e) {
      this.rowList = e;
    },
    // 提示框
    open(text) {
      this.$alert(text, '提示', {
        confirmButtonText: '确定',
      }).catch(() => {

      });
    },
    batchDelete() {
      if (this.checkNum < 1) {
        this.open('请先选择要删除的药品');
      } else {
        this.$confirm('确认删除这些药片？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
        }).then(() => {
          this.drugsDelMore();
        }).catch(() => {
        });
      }
    },
    itemDelete() {
      this.$confirm('确认删除“舒腹贴膏”？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
    batchType() {
      if (this.checkNum < 1) {
        this.open('请先选择要自定义分类的药品');
      } else {
        this.$prompt('自定义分类：', '批量修改分类', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.batchModifyDrugCustomType(value);
        }).catch(() => {});
      }
    },
    toAdd() {
      this.$router.push({ name: 'drugDetail', query: { state: 'add' } });
    },
    toEdit(drugIds) {
      this.$router.push({ name: 'drugDetail', query: { state: 'edit', drugId: drugIds } });
    },
    toQuick() {
      this.$router.push({ name: 'quickEdit', query: { state: 'add', ...this.query } });
    },
    // 筛选触发事件
    queryChangeHandle() {
      this.setPath({
        drugName: this.query.drugName,
        drugType: this.query.drugType,
        customType: this.customType,
        status: this.query.status,
        currentPage: this.query.currentPage,
      });
    },
    // 通过url初始化筛选项
    initQuery() {
      const queryUrl = this.getPath();
      this.query.drugName = queryUrl.drugName ? queryUrl.drugName : '';
      this.query.drugType = queryUrl.drugType ? Number(queryUrl.drugType) : -1;
      this.query.status = queryUrl.status ? Number(queryUrl.status) : 1;
      this.query.customType = queryUrl.customType ? Number(queryUrl.customType) : '';
      this.query.currentPage = queryUrl.currentPage ? Number(queryUrl.currentPage) : 1;
      this.getTableData();
    },
    // 下载导入药品信息EXCEL模板
    downloadTemplate() {
      this.$api.drugControl.downloadDrugInfomationTemplate().then(() => {
        this.$message({
          type: 'success',
          message: '下载模板成功！',
        });
      });
    },
    // 上传文件时的校验
    beforeUpload(file) {
      const reg = /\.xlsx$/;
      if (reg.test(file.name)) {
        console.log('格式正确');
      } else {
        this.$message({
          type: 'error',
          message: '上传文件格式需为.xlsx文件！',
        });
      }
    },
    // 上传文件超出限制时的操作
    handleExceed(file) {
      this.$message.warning(`当前上传限制选择 1 个文件，本次选择了 ${file.length} 个文件`);
    },
    // 上传移除文件时确认
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}?`);
    },
    // 点击文件上传时二次确认
    handlePreview(file) {
      return this.$message.success(`${file.name} 已上传成功`);
    },
    // 文件上传成功
    uploadSuccess(file, fileList) {
      const files = JSON.parse(fileList.response);
      console.log('测试', fileList);
      // let arr = '';
      if (files.errorCode === 0) {
        this.fileList.push({
          name: files.name,
          url: files.data[0],
        });
        this.$message.success(`${fileList.name}+上传成功`);
        this.getTableData(1);
      } else {
        this.$message.error(`上传失败!${files.errorMsg}`);
        console.log(file);
        this.fileList.pop();
      }
    },
  },
  mounted() {
    this.initQuery();
  },
  watch: {
    fileList: {
      immediate: true,
      handler(val) {
        this.fileList = val;
      },
    },
  },
};
